<template>
  <div>
    <UserAccountContainer :user="user" :plan="getActivePlan" :sub="getActiveSubscription" :loadingSubscriptions="loadingSubscriptions" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserAccountContainer from '../../components/UserAccount/UserAccountContainer.vue'

export default {
  name: 'AccountMgmt',
  components: { UserAccountContainer },
  data() {
    return {
      edit: false,
      user: {},
      loadingSubscriptions: false
    }
  },
  computed: {
    ...mapGetters(['getMyInfo', 'getActivePlan', 'getActiveSubscription'])
  },
  methods: {
    ...mapActions(['getMe', 'loadActiveSubscriptions'])
  },
  mounted: async function() {
    this.loadingSubscriptions = true
    if (!this.getMyInfo) await this.getMe()
    this.user = this.getMyInfo
    await this.loadActiveSubscriptions()
    this.loadingSubscriptions = false
  },
  watch: {
    getMyInfo(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.user = this.getMyInfo
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AccountMgmt/AccountMgmt.vue?1c3f4e9b